import React, { useRef, useEffect } from 'react'

import InputField from 'src/components/InputField'
import CheckBox   from 'src/components/CheckBox'

const SignIn = props => {
  const passwordField = useRef()
  const mounted = useRef()

  const hidden = props.action != props.urls.signin
  const tabIndex = hidden ? -1 : null

  useEffect(() => {
    if (mounted.current && !hidden)
      setTimeout(() => passwordField.current.focus(), 1)
  }, [ hidden ])

  useEffect(() => {
    mounted.current = true
    return () => mounted.current = false
  }, [])

  return (
    <div aria-hidden={hidden}>
      <InputField
        {...props.inputProps('password')}
        ref={passwordField}
        type="password"
        label="Password"
        onChange={props.handleSignInPasswordChange}
        tabIndex={tabIndex}
        autoComplete="current-password"
        required
      />
      <div className="mb-3">
        <CheckBox
          {...props.booleanProps('remember_me')}
          label="Stay signed in"
          tabIndex={tabIndex}
        />
      </div>
    </div>
  )
}

export default SignIn
